import { render, staticRenderFns } from "./AddHoliday.vue?vue&type=template&id=40977539&scoped=true&"
import script from "./AddHoliday.vue?vue&type=script&lang=js&"
export * from "./AddHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40977539",
  null
  
)

export default component.exports